module.exports = __webpack_public_path__ + "static/media/romania.a9894617.svg";